module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_016.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_016.png
// module id = 2363
// module chunks = 5